import React from 'react'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import EditableAddress from './EditableAddress'

function SupplierAddresses (props) {
  const {
    billingAddress,
    deliveryAddress,
    supplierDeliveryAddresses,
    supplierBillingAddresses,
    onBillingAddressChange,
    onDeliveryAddressChange
  } = props

  return (
    <Grid container={true} spacing={3}>
      <Grid item={true} xs={12} lg={6}>
        <EditableAddress
          title="Supplier address"
          name="deliveryAddress"
          value={deliveryAddress}
          address={deliveryAddress}
          options={supplierDeliveryAddresses}
          onChange={onDeliveryAddressChange}
        />
      </Grid>
      <Grid item={true} xs={12} lg={6}>
        <EditableAddress
          title="Billing address"
          name="billingAddress"
          value={billingAddress}
          address={billingAddress}
          options={supplierBillingAddresses}
          onChange={onBillingAddressChange}
        />
      </Grid>
    </Grid>
  )
}

SupplierAddresses.propTypes = {
  billingAddress: PropTypes.object.isRequired,
  deliveryAddress: PropTypes.object.isRequired,
  supplierDeliveryAddresses: PropTypes.array.isRequired,
  supplierBillingAddresses: PropTypes.array.isRequired,
  onBillingAddressChange: PropTypes.func.isRequired,
  onDeliveryAddressChange: PropTypes.func.isRequired
}

export default SupplierAddresses
